import React from "react";
import VacatureList from "../shared/Vacatures"

class MyVacancies extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
            pk: props.par.pk,
        }
    }

    render() {
        return (
            <div>
                <VacatureList url={"jobbeurs/companies/" + this.state.pk + "/vacatures/"} authenticate={false} soort={"both"} />
            </div>
        );
    }
}

export default MyVacancies;
